import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel } from '@libs/shared/models';
import { NavLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-toggle-navigation-item',
  templateUrl: './toggle-navigation-item.component.html',
  styleUrls: ['./toggle-navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCardModule,
    NavLinkDirective,
    IconComponent,
  ],
})
export class ToggleNavigationItemComponent {
  public item: InputSignal<NavItemModel> = input.required();
  public mode: InputSignal<'link' | 'button'> = input.required();
  public title: InputSignal<string | undefined> = input();
  public chevron: InputSignal<boolean> = input(false);
}
